import { render, staticRenderFns } from "./OptionsItemsList.vue?vue&type=template&id=50765293&"
import script from "./OptionsItemsList.vue?vue&type=script&lang=js&"
export * from "./OptionsItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports